<template>
	<component :key="key" :is="formModule.component" :name="formModule.name" :id="formModule.id"
		:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
		:windowType="formModule.windowType" @back="formBack" :windowName="formModule.windowName"
		:isflow="formModule.isflow" :flowprogressid="formModule.flowprogressid" :flowid="formModule.flowid"
		:device="formModule.device" @activeEdit="activeEdit" @show="formshow" @reloadList="reloadList" />
</template>
<style scoped>


</style>
<script>
	// import {
	// 	Loading
	// } from 'element-ui';
	import listBase from '@_system/components/base/list.vue'
	import loginMixins from '@_system/components/base/mixins/login/login.js'
	export default {
		mixins: [loginMixins],
		extends: listBase,
		props: {
			formConfig: {
				type: Object,
				default: () => {
					return {
						name: '',
						id: 0,
						controlltype: 1,
						foreingKey: {},
						extra: {},
						windowTitle: '',
						windowName: '',
						windowType: 'modal',
						isflow: false,
						flowprogressid: 0,
						flowid: 0,
						moduletype: '',
						device: window.systemMethods.device()
					}
				}
			},

		},
		data() {
			return {
				demoshow: true,
				key: Math.random(),
				moduleName: this.formConfig.name,
				exportData: [],
				loading: false,
				show: false,
				loadhandle: null
			}
		},
		watch: {
			'$route'() {
				// 当路由发生变化时执行的操作
				this.load()
			}
		},
		computed: {
			nameMap() {
				return this.$store.state.formMap
			},
			systemnameMap() {
				return this.$store.state.system.formMap
			}
		},
		created() {


			//this.formModule = this.formConfig
		},
		mounted() {
			if (!this.$store.state.system.systemdata) {
				this.login_init()
			}else{
				this.login_handle()
			}
		},
		methods: {
			login_after() {
				this.load()
			},			
			load(){
				if (this.formConfig.moduletype == 'system' && this.systemnameMap[this.formConfig.name] || this.nameMap[this
						.formConfig.name]) {
					if (this.formConfig.windowType === 'window') {
						window.document.title = this.formConfig.windowName
					}
					this.init()
				} else {
					this.$emit('back', 'cancle')
					//this.loadhandle.close()
					this.$message.error('表单路径不存在')
				}
			},
			initList() {

			},
			init() {
				// this.loadhandle = Loading.service({
				// 	spinner: 'el-icon-loading',
				// 	text: '',
				// 	background: "rgba(255, 255, 255, 0.3)"
				// })
				if (this.formConfig.moduletype == 'system') {
					import(`@_system/${this.systemnameMap[this.formConfig.name]}`).then((res) => {
						this.formModule = {
							component: res.default,
							name: this.formConfig.name,
							id: this.formConfig.id,
							foreingKey: this.formConfig.foreingKey,
							extra: this.formConfig.extra,
							controlltype: this.formConfig.controlltype,
							windowName: this.formConfig.windowName,
							windowType: this.formConfig.windowType,
							isflow: this.formConfig.isflow,
							flowprogressid: this.formConfig.flowprogressid,
							flowid: this.formConfig.flowid,
							device: this.formConfig.device ? this.formConfig.device : window.systemMethods
								.device()
						}
					})
				} else {
					import(`@/${this.nameMap[this.formConfig.name]}`).then((res) => {
						this.formModule = {
							component: res.default,
							name: this.formConfig.name,
							id: this.formConfig.id,
							foreingKey: this.formConfig.foreingKey,
							extra: this.formConfig.extra,
							controlltype: this.formConfig.controlltype,
							windowName: this.formConfig.windowName,
							windowType: this.formConfig.windowType,
							isflow: this.formConfig.isflow,
							flowprogressid: this.formConfig.flowprogressid,
							flowid: this.formConfig.flowid,
							device: this.formConfig.device ? this.formConfig.device : window.systemMethods
								.device()
						}
					})
				}
			},
			formBack(e) {
				//this.loadhandle.close()
				this.$emit('back', e)
			},
			reloadList() {
				this.$emit('reloadList')
			},
			formshow() {
				//this.loadhandle.close()
			},
			activeEdit() {
				this.$api.form.create({
					id: this.formConfig.name,
					controlltype: 2,
					isflow: this.formConfig.isflow,
					flowprogressid: this.formConfig.flowprogressid,
					flowid: this.formConfig.flowid
				}).then(() => {
					this.formModule.controlltype = 2
					this.key = Math.random()
				})
				//console.log(this.formConfig)
			}
		}
	}
</script>